import React from 'react';
import { useParams } from 'react-router-dom';

export const ParamsTest: React.FC = () => {
  const params = useParams();
  
  console.log('🧪 [ParamsTest] Direct params test:', {
    params,
    keys: Object.keys(params),
    values: Object.values(params),
    pathname: window.location.pathname
  });
  
  return (
    <div style={{ padding: '20px', background: '#f0f0f0' }}>
      <h2>Params Test Component</h2>
      <pre>{JSON.stringify(params, null, 2)}</pre>
      <p>Path: {window.location.pathname}</p>
    </div>
  );
};